<template lang="pug">
  .b2b-page-mailServer
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(v-if='!this.isNuevo', :span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(v-if='this.isNuevo', :span='8')
            div {{ $t('mailServer.new') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("mailServer.delete_mailServer_tooltip")', placement='bottom')
                ods-button(
                  v-if='!this.isNuevo && this.canAdminIndra && this.mailServerDetailEditForm.id != 1'
                  type='primary',
                  icon='ods-icon-delete',
                  size='small',
                  circle,
                  @click.native='handleRemoveMailServer')
                  | {{ $t('buttons.btnDelete') }}
              ods-tooltip(:content='$t("mailServer.test_tooltip")', placement='bottom')
                ods-button(
                  type='primary',
                  icon='ods-icon-help',
                  size='small',
                  circle,
                  @click.native='handleTestConnection("mailServerDetailEditForm")')
                  | {{ $t('mailServer.test') }}
      ods-form(
        ref='mailServerDetailEditForm',
        :model='mailServerDetailEditForm',
        :rules='rulesMailServerDetailEditForm',
        label-width='14rem',
        label-position='top',
        size='mini',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("mailServer.mailServer_table.protocol")',
              prop='protocol')
              ods-select(
                v-model='mailServerDetailEditForm.protocol',
                :placeholder='$t("mailServer.mailServer_table.protocol")',
                @change='handleProtocolChange')
                ods-option(
                  v-for='option in optionsProtocol',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              v-if='mailServerDetailEditForm.protocol === "smtp"',
              :label='$t("mailServer.mailServer_table.host")',
              prop='host')
              ods-input(
                v-model='mailServerDetailEditForm.host')
          ods-col(:span='1')
          ods-col(:span='10')
            ods-form-item(
              v-if='mailServerDetailEditForm.protocol === "smtp"',
              :label='$t("mailServer.mailServer_table.user")',
              prop='user')
              ods-input(
                autocomplete='off',
                type='text',
                v-model='mailServerDetailEditForm.user')
        ods-row(type='flex' v-if='mailServerDetailEditForm.protocol === "smtp"')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("mailServer.mailServer_table.password")',
              prop='password')
              ods-input(
                autocomplete='new-password'
                show-password
                type='password',
                v-model='mailServerDetailEditForm.password')
          ods-col(:span='1')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("mailServer.mailServer_table.mailfrom")',
              prop='mailFrom')
              ods-input(
                v-model='mailServerDetailEditForm.mailFrom')
        ods-row(type='flex' v-if='mailServerDetailEditForm.protocol === "exchange"')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("mailServer.mailServer_table.mailfrom")',
              prop='mailFrom')
              ods-input(
                v-model='mailServerDetailEditForm.mailFrom')
          ods-col(:span='11')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              v-if='mailServerDetailEditForm.protocol === "smtp"',
              :label='$t("mailServer.mailServer_table.port")',
              prop='port')
              ods-input(
                placeholder='25',
                v-model='mailServerDetailEditForm.port')
          ods-col(:span='1')
          ods-col(:span='10')
            ods-form-item(
              v-if='mailServerDetailEditForm.protocol === "smtp"',
              :label='$t("mailServer.mailServer_table.auth")',
              prop='auth')
              ods-switch(
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                v-model='mailServerDetailEditForm.auth')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              v-if='mailServerDetailEditForm.protocol === "exchange"',
              :label='$t("mailServer.mailServer_table.idClient")',
              prop='idClient')
              ods-input(
                v-model='mailServerDetailEditForm.idClient')
          ods-col(:span='1')
          ods-col(:span='10')
            ods-form-item(
              v-if='mailServerDetailEditForm.protocol === "exchange"',
              :label='$t("mailServer.mailServer_table.idTenant")',
              prop='idTenant')
              ods-input(
                v-model='mailServerDetailEditForm.idTenant')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              v-if='mailServerDetailEditForm.protocol === "exchange"',
              :label='$t("mailServer.mailServer_table.clientSecret")',
              prop='clientSecret')
              ods-input(
                autocomplete='new-password'
                show-password
                type='password',
                v-model='mailServerDetailEditForm.clientSecret')
          ods-col(:span='1')
          ods-col(:span='10')
            ods-form-item(
              v-if='mailServerDetailEditForm.protocol === "exchange"',
              :label='$t("mailServer.mailServer_table.saveToSentItems")',
              prop='saveToSentItems')
              ods-switch(
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                v-model='mailServerDetailEditForm.saveToSentItems')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              v-if='mailServerDetailEditForm.protocol === "exchange"',
              :label='$t("mailServer.mailServer_table.validityDateTo")',
              :formatter='formatterDate',
              prop='validityDateTo')
              ods-date-picker(
                v-model='mailServerDetailEditForm.validityDateTo',
                type='date',
                :format='$t("date_format_calendar")',
                prefix-icon='prefix-icon-date-time-picker',
                :placeholder='$t("msg_generics.date_required")')
            ods-col(:span='1')
    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='large'
            @click='saveMailServer("mailServerDetailEditForm")')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
          ods-button(
            ref='buttonCancel',
            type='neutral',
            size='large'
            @click='cancelmailServerDetailEditForm')
            | {{ $t('buttons.btnClear') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'
import router from '@/router/index'
import moment from 'moment'

export default {
  name: 'b2b-page-mailServer',
  mixins: [Utils],
  data () {
    return {
      tableMailServerSort: {
        prop: 'id',
        order: 'descending'
      },
      isNuevo: false,
      multipleSelectionIds: [],
      showDeleteSelection: false,
      optionsDelete: [
        { value: true, label: this.$t('msg_generics.question.yes') }, { value: false, label: this.$t('msg_generics.question.no') }],
      // Combo protocolo
      optionsProtocol: [
        {
          value: 'smtp',
          label: 'SMTP'
        },
        {
          value: 'exchange',
          label: 'Exchange'
        }
      ],
      // INFO
      mailServerId: null,
      mailServerDetailEditForm: {
        // EDITABLES
        user: null,
        password: null,
        host: null,
        mailFrom: null,
        port: null,
        protocol: 'smtp',
        auth: true,
        idClient: null,
        idTenant: null,
        clientSecret: null,
        saveToSentItems: true,
        validityDateTo: null
      }
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      'canAdminIndra',
      'primaryColor'
    ]),
    rulesMailServerDetailEditForm () {
      const validateEmail = (rule, value, callback) => {
        if (this.checkCorrectEmail(value)) { // eslint-disable-line
          callback()
        } else if (value == null || value === '') { // eslint-disable-line
          callback()
        } else {
          callback(new Error(this.$t('msg_generics.emailKo')))
        }
      }
      const validaRequiredByAuth = (rule, value, callback) => {
        if ((value == null || value === '') && this.mailServerDetailEditForm.protocol === 'smtp') { // eslint-disable-line
          console.log('validaRequiredByAuth')
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }
      const validaRequiredByProtocol = (rule, value, callback) => {
        if (this.mailServerDetailEditForm.protocol === 'smtp') {
          if ((value == null || value === '') && this.mailServerDetailEditForm.auth) { // eslint-disable-line
            callback(new Error(this.$t('msg_generics.field_required')))
          } else {
            callback()
          }
        } else if (this.mailServerDetailEditForm.protocol === 'exchange') {
          if (value == null || value === '') { // eslint-disable-line
            callback(new Error(this.$t('msg_generics.field_required')))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      return {
        user: [
          { required: this.mailServerDetailEditForm.protocol === 'smtp', message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        password: [
          { validator: validaRequiredByAuth, trigger: 'change' }
        ],
        host: [
          { required: this.mailServerDetailEditForm.protocol === 'smtp', message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        mailFrom: [
          { required: true, validator: validateEmail, trigger: 'change' }
        ],
        auth: [
          { required: this.mailServerDetailEditForm.protocol === 'smtp', message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        protocol: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        idClient: [
          { required: this.mailServerDetailEditForm.protocol === 'exchange', validator: validaRequiredByProtocol, trigger: 'change' }
        ],
        idTenant: [
          { required: this.mailServerDetailEditForm.protocol === 'exchange', validator: validaRequiredByProtocol, trigger: 'change' }
        ],
        clientSecret: [
          { required: this.mailServerDetailEditForm.protocol === 'exchange', validator: validaRequiredByProtocol, trigger: 'change' }
        ],
        saveToSentItems: [
          { required: this.mailServerDetailEditForm.protocol === 'exchange', validator: validaRequiredByProtocol, trigger: 'change' }
        ],
        validityDateTo: [
          { required: this.mailServerDetailEditForm.protocol === 'exchange', validator: validaRequiredByProtocol, trigger: 'change' }
        ]

      }
    }
  },

  methods: {
    ...mapActions([
      'getMailServerDetail',
      'modifyMailServer',
      'deleteMailServer',
      'testMailServer'
    ]),

    /** Guarda los cambios del servidor */
    saveMailServer (formName) {
      console.log('saveMailServer')
      const self = this
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = self.$loading({
            lock: true
          })
          try {
            console.log('try saveMailServer')
            const request = {
              mailServerId: this.mailServerId,
              user: self.mailServerDetailEditForm.user,
              password: self.mailServerDetailEditForm.password,
              host: self.mailServerDetailEditForm.host,
              mailFrom: self.mailServerDetailEditForm.mailFrom,
              port: self.mailServerDetailEditForm.port ? self.mailServerDetailEditForm.port : (self.mailServerDetailEditForm.protocol === 'smtp' ? 25 : null),
              protocol: self.mailServerDetailEditForm.protocol,
              auth: self.mailServerDetailEditForm.auth,
              idClient: self.mailServerDetailEditForm.idClient,
              idTenant: self.mailServerDetailEditForm.idTenant,
              clientSecret: self.mailServerDetailEditForm.clientSecret,
              saveToSentItems: self.mailServerDetailEditForm.saveToSentItems,
              validityDateTo: self.mailServerDetailEditForm.validityDateTo
            }

            console.log('saveToSentItems: ', request.saveToSentItems)
            const response = await self.modifyMailServer(request)
            self.mailServerDetailEditForm = response.data
            this.mailServerId = self.mailServerDetailEditForm.id
            this.isNuevo = false

            router.push({ name: 'mailServer-page' })
            let resultMsg = this.$t('mailServer.notify.save_changes')
            if (this.isNuevo) {
              resultMsg = this.$t('mailServer.notify.add_mailServer')
            }
            self.$notify({
              title: resultMsg,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            self.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log(
            'submitmailServerDetailEditForm: ',
            self.mailServerDetailEditForm
          )
        }
      })
    },
    handleProtocolChange () {
      this.$refs.mailServerDetailEditForm.clearValidate()
    },
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },
    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.showDeleteSelection = false
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
      if (this.multipleSelectionIds && this.multipleSelectionIds.length > 0) {
        this.showDeleteSelection = true
      }
    },
    /* Eliminar el servidor de email */
    async handleRemoveMailServer (mailServer) {
      this.$confirm(this.$t('mailServer.confirm.delete_mailServer'), {
        confirmButtonText: this.$t('buttons.btnDelete'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('mailServer.load.delete_mailServer')
        })
        try {
          await this.deleteMailServer({ mailServerId: this.mailServerId })
          this.$notify({
            title: this.$t('mailServer.notify.delete_mailServer'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })

          router.push({ name: 'mailServer-page' })
        } catch (error) {
          console.log('handleRemoveMailServer CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },
    async handleTestConnection (formName) {
      const self = this
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = self.$loading({
            lock: true
          })
          try {
            const request = {
              mailServerId: this.mailServerId,
              user: self.mailServerDetailEditForm.user,
              password: self.mailServerDetailEditForm.password,
              host: self.mailServerDetailEditForm.host,
              mailFrom: self.mailServerDetailEditForm.mailFrom,
              port: self.mailServerDetailEditForm.port ? self.mailServerDetailEditForm.port : 25,
              protocol: self.mailServerDetailEditForm.protocol,
              auth: self.mailServerDetailEditForm.auth,
              idClient: self.mailServerDetailEditForm.idClient,
              idTenant: self.mailServerDetailEditForm.idTenant,
              clientSecret: self.mailServerDetailEditForm.clientSecret,
              saveToSentItems: self.mailServerDetailEditForm.saveToSentItems,
              validityDateTo: self.mailServerDetailEditForm.validityDateTo
            }
            await self.testMailServer(request)
            self.$notify({
              title: this.$t('mailServer.test_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            self.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log(
            'submitmailServerDetailEditForm: ',
            self.mailServerDetailEditForm
          )
        }
      })
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          if (error.data.message) { errorSms = error.data.message } else { errorSms = error.message }
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },
    async cancelmailServerDetailEditForm () {
      const load = this.$loading({
        lock: true
      })
      try {
        // Quitamos el foco del boton
        this.$refs.buttonCancel.$el.blur()
        await this.getMailServerOnDatabase()
      } catch (error) {
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    },

    async getMailServerOnDatabase () {
      try {
        if (this.mailServerId) {
          const response = await this.getMailServerDetail(this.mailServerId)
          this.mailServerDetailEditForm = response
        } else {
          this.$refs.mailServerDetailEditForm.resetFields()
          this.mailServerDetailEditForm.protocol = 'smtp'
        }
      } catch (error) {
        this.showNotificationError(error)
      }
    },
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRowDataconfiguration = row
    }
  },
  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })

    try {
      this.mailServerId = this.$route.params.mailServerId
      if (this.$route.params.mailServerId == 'newMailServer') { // eslint-disable-line
        this.isNuevo = true
        this.mailServerId = null
      }
      if (!this.isNuevo) {
        // Get Info
        await this.getMailServerOnDatabase()
      }
    } catch (error) {
      console.log('Info: Inicializando datos created')
      this.showNotificationError(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-mailServer {
    padding: 40px 40px 40px 40px;

  .ods-table {
    &__row {
      .ods-button {
        padding: 0px;
        margin-left: 0px;
        margin-right: 0px;
        i {
          margin-left: 0px;
        }
      }
      .first-button {
        padding: 0px;
        margin-left: 0px;
        margin-right: rem(12);
        i {
          margin-left: 0px;
        }
      }
    }
  }

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;

      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
      .ods-button {
        float: right;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
  ::v-deep .ods-checkbox {
    padding-top: 20px;
  }
}
</style>
